var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GangsTabs'),_c('div',{staticClass:"anim-fade-in"},_vm._l((_vm.items),function(item){return _c('GangBuilding',{key:item.id,attrs:{"building":item}})}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }